import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import { useAuth } from '../contexts/AuthContext';
import AuthGuard from '../contexts/AuthGuard';
import Dashboard from '../pages/modules/admin/dashboard/Dashboard';
import Distributors from '../pages/modules/admin/user-management/Distributors/Distributors';
import FOS from '../pages/modules/admin/user-management/FOS/FOS';
import Retailers from '../pages/modules/admin/user-management/Retailers/Retailers';
import DistributorConfig from '../pages/modules/admin/distributor-config/DistributorConfig';
import Plans from '../pages/modules/admin/plans/Plans';
import Subscriptions from '../pages/modules/admin/subscriptions/Subscriptions';

// Distributor Module Components
import DistributorDashboard from '../pages/modules/distributor/dashboard/DistributorDashboard';
import Supports from '../pages/modules/distributor/supports/Supports';
import DistributorFOS from '../pages/modules/distributor/fos/DistributorFOS';
import DistributorRetailers from '../pages/modules/distributor/retailers/DistributorRetailers';
import CollectRetailerOutstanding from '../pages/modules/distributor/collect-outstanding/CollectRetailerOutstanding';
import CollectFOSCollection from '../pages/modules/distributor/collect-outstanding/CollectFOSCollection';
import CollectionReports from '../pages/modules/distributor/reports/CollectionReports';
import PaymentGatewayConfig from '../pages/modules/distributor/config/PaymentGatewayConfig';
import OutstandingUpload from '../pages/modules/distributor/upload/OutstandingUpload';
import PortalLoginConfig from '../pages/modules/distributor/config/PortalLoginConfig';

const AdminRoutes = () => {
  const { logout } = useAuth();

  return (
    <AuthGuard>
      <Routes>
        <Route element={<AdminLayout onLogout={logout} />}>
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/distributor" element={<Navigate to="/distributor/dashboard" replace />} />
        
        {/* Admin Module Routes */}
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/user-management/distributors" element={<Distributors />} />
        <Route path="/admin/user-management/fos" element={<FOS />} />
        <Route path="/admin/user-management/retailers" element={<Retailers />} />
        <Route path="/admin/distributor-config" element={<DistributorConfig />} />
        <Route path="/admin/plans" element={<Plans />} />
        <Route path="/admin/subscriptions" element={<Subscriptions />} />
        
        {/* Distributor Module Routes */}
        <Route path="/distributor/dashboard" element={<DistributorDashboard />} />
        <Route path="/distributor/supports" element={<Supports />} />
        <Route path="/distributor/fos" element={<DistributorFOS />} />
        <Route path="/distributor/retailers" element={<DistributorRetailers />} />
        <Route path="/distributor/collect/retailer-outstanding" element={<CollectRetailerOutstanding />} />
        <Route path="/distributor/collect/fos-collection" element={<CollectFOSCollection />} />
        <Route path="/distributor/reports/collections" element={<CollectionReports />} />
        <Route path="/distributor/config/payment-gateway" element={<PaymentGatewayConfig />} />
        <Route path="/distributor/upload/outstanding" element={<OutstandingUpload />} />
        <Route path="/distributor/config/portal-login" element={<PortalLoginConfig />} />
        
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Route>
    </Routes>
    </AuthGuard>
  );
};

export default AdminRoutes;

